// GENERATED by tools/extract-instrument-geo.py — do not edit by hand
// Instrument monitoring sections + settlement crosses (real lat/lng from Klongprem KML)
// pure data + math — no maplibre/three import (jest-safe)

export const INSTRUMENT_META = {
  EXT: { label: "Extensometer", shape: "square" },
  INC: { label: "Inclinometer", shape: "circle" },
  VW:  { label: "VW Piezometer", shape: "triangle" },
};

export const INSTRUMENT_SECTIONS = [
  {"id":"IM-01","lng":100.5533092,"lat":13.8370446,"chainage":8131.0,"types":["EXT","INC","VW"],"aboveTunnel":false},
  {"id":"IM-02","lng":100.5568669,"lat":13.8427422,"chainage":7393.9,"types":["EXT","INC"],"aboveTunnel":true},
  {"id":"IM-03","lng":100.5600337,"lat":13.8492334,"chainage":6599.1,"types":["EXT","INC"],"aboveTunnel":true},
  {"id":"IM-04","lng":100.5675406,"lat":13.8625541,"chainage":4914.4,"types":["EXT","INC","VW"],"aboveTunnel":false},
  {"id":"IM-05","lng":100.5702494,"lat":13.8675243,"chainage":4291.0,"types":["EXT","INC","VW"],"aboveTunnel":false},
  {"id":"IM-06","lng":100.5731036,"lat":13.8728492,"chainage":3625.9,"types":["EXT","INC","VW"],"aboveTunnel":false},
  {"id":"IM-07","lng":100.5762605,"lat":13.878556,"chainage":2908.2,"types":["EXT","INC","VW"],"aboveTunnel":false},
  {"id":"IM-08","lng":100.5802139,"lat":13.8857201,"chainage":2007.0,"types":["EXT","INC","VW"],"aboveTunnel":false},
  {"id":"IM-09","lng":100.5858679,"lat":13.8900846,"chainage":1057.8,"types":["EXT","INC","VW"],"aboveTunnel":false},
  {"id":"IM-10","lng":100.5914175,"lat":13.8888233,"chainage":423.1,"types":["EXT","INC","VW"],"aboveTunnel":false},
];

// each entry = one drawn stroke [[lng,lat],[lng,lat]] (2 strokes make a '+')
export const SETTLEMENT_CROSSES = [
  [[100.5812098,13.8884055],[100.5812034,13.8883925]],
  [[100.5812133,13.8883959],[100.5811999,13.8884021]],
  [[100.5812735,13.8883688],[100.5812671,13.8883557]],
  [[100.581277,13.8883591],[100.5812636,13.8883654]],
  [[100.5813213,13.8883412],[100.581315,13.8883282]],
  [[100.5813248,13.8883316],[100.5813115,13.8883378]],
  [[100.5813532,13.8883229],[100.5813468,13.8883098]],
  [[100.5813567,13.8883132],[100.5813433,13.8883195]],
  [[100.5813692,13.8883137],[100.5813628,13.8883006]],
  [[100.5813727,13.888304],[100.5813593,13.8883103]],
  [[100.5813851,13.8883045],[100.5813787,13.8882915]],
  [[100.5813886,13.8882949],[100.5813752,13.8883011]],
  [[100.5814011,13.8883371],[100.5813947,13.8883241]],
  [[100.5814046,13.8883275],[100.5813912,13.8883337]],
  [[100.5814251,13.888386],[100.5814187,13.888373]],
  [[100.5814286,13.8883764],[100.5814152,13.8883826]],
  [[100.5811216,13.8882082],[100.5811153,13.8881952]],
  [[100.5811251,13.8881986],[100.5811118,13.8882048]],
  [[100.5811891,13.8881785],[100.5811827,13.8881654]],
  [[100.5811926,13.8881688],[100.5811792,13.8881751]],
  [[100.5812397,13.8881562],[100.5812333,13.8881431]],
  [[100.5812432,13.8881465],[100.5812298,13.8881528]],
  [[100.5812734,13.8881413],[100.5812671,13.8881283]],
  [[100.5812769,13.8881317],[100.5812636,13.8881379]],
  [[100.5813072,13.8881264],[100.5813008,13.8881134]],
  [[100.5813107,13.8881168],[100.5812973,13.888123]],
  [[100.5812891,13.8880949],[100.5812827,13.8880818]],
  [[100.5812926,13.8880852],[100.5812792,13.8880915]],
  [[100.581262,13.8880476],[100.5812556,13.8880345]],
  [[100.5812655,13.8880379],[100.5812521,13.8880441]],
  [[100.5812258,13.8879845],[100.5812195,13.8879714]],
  [[100.5812293,13.8879748],[100.581216,13.887981]],
  [[100.5952834,13.887683],[100.5952735,13.8876723]],
  [[100.5952729,13.8876825],[100.5952839,13.8876728]],
  [[100.5952294,13.8877325],[100.5952195,13.8877217]],
  [[100.5952189,13.8877319],[100.5952299,13.8877222]],
  [[100.5951888,13.8877695],[100.5951789,13.8877588]],
  [[100.5951784,13.887769],[100.5951894,13.8877593]],
  [[100.5951618,13.8877943],[100.5951519,13.8877835]],
  [[100.5951514,13.8877937],[100.5951624,13.887784]],
  [[100.5951348,13.887819],[100.5951249,13.8878082]],
  [[100.5951244,13.8878184],[100.5951354,13.8878088]],
  [[100.5951119,13.8877906],[100.595102,13.8877798]],
  [[100.5951015,13.88779],[100.5951125,13.8877803]],
  [[100.5950776,13.8877479],[100.5950677,13.8877372]],
  [[100.5950672,13.8877474],[100.5950782,13.8877377]],
  [[100.5950319,13.8876911],[100.595022,13.8876803]],
  [[100.5950214,13.8876906],[100.5950324,13.8876809]],
  [[100.5534004,13.8370755],[100.5534138,13.8370693]],
  [[100.5534039,13.8370658],[100.5534102,13.8370789]],
  [[100.5533683,13.8370936],[100.5533812,13.8370865]],
  [[100.5533712,13.8370837],[100.5533784,13.8370964]],
  [[100.5533199,13.8371201],[100.5533328,13.837113]],
  [[100.5533227,13.8371102],[100.55333,13.8371228]],
  [[100.5532553,13.8371554],[100.5532682,13.8371483]],
  [[100.5532581,13.8371455],[100.5532654,13.8371582]],
  [[100.5594591,13.8481376],[100.5594721,13.8481307]],
  [[100.5594621,13.8481278],[100.5594691,13.8481405]],
  [[100.5593276,13.8478988],[100.5593406,13.8478919]],
  [[100.5593306,13.847889],[100.5593376,13.8479017]],
  [[100.5591961,13.84766],[100.5592091,13.8476531]],
  [[100.5591991,13.8476502],[100.5592061,13.8476629]],
  [[100.5612022,13.8512993],[100.5612152,13.8512925]],
  [[100.5612052,13.8512895],[100.5612122,13.8513023]],
  [[100.5610704,13.8510607],[100.5610834,13.8510538]],
  [[100.5610734,13.8510509],[100.5610804,13.8510636]],
  [[100.5609386,13.850822],[100.5609517,13.8508152]],
  [[100.5609416,13.8508122],[100.5609487,13.850825]],
  [[100.5628514,13.8543325],[100.5628645,13.8543256]],
  [[100.5628545,13.8543227],[100.5628615,13.8543354]],
  [[100.56272,13.8540936],[100.5627331,13.8540868]],
  [[100.562723,13.8540838],[100.56273,13.8540966]],
  [[100.5625885,13.8538548],[100.5626016,13.853848]],
  [[100.5625915,13.853845],[100.5625986,13.8538578]],
  [[100.5668988,13.8617154],[100.5669119,13.8617087]],
  [[100.5669019,13.8617057],[100.5669088,13.8617185]],
  [[100.5667698,13.8614754],[100.5667829,13.8614686]],
  [[100.5667729,13.8614656],[100.5667798,13.8614784]],
  [[100.5666407,13.8612353],[100.5666538,13.8612286]],
  [[100.5666438,13.8612255],[100.5666507,13.8612384]],
  [[100.5695852,13.866735],[100.5695983,13.8667282]],
  [[100.5695883,13.8667252],[100.5695952,13.866738]],
  [[100.5694559,13.866495],[100.569469,13.8664883]],
  [[100.569459,13.8664853],[100.5694659,13.8664981]],
  [[100.5693266,13.8662551],[100.5693397,13.8662484]],
  [[100.5693297,13.8662453],[100.5693366,13.8662581]],
  [[100.571022,13.869282],[100.5710351,13.8692753]],
  [[100.5710251,13.8692723],[100.571032,13.8692851]],
  [[100.5708928,13.869042],[100.5709059,13.8690353]],
  [[100.5708959,13.8690323],[100.5709028,13.8690451]],
  [[100.5707637,13.868802],[100.5707768,13.8687953]],
  [[100.5707668,13.8687923],[100.5707737,13.8688051]],
  [[100.5724982,13.8720307],[100.5725113,13.8720239]],
  [[100.5725013,13.8720209],[100.5725082,13.8720337]],
  [[100.572369,13.8717907],[100.5723821,13.8717839]],
  [[100.5723721,13.8717809],[100.572379,13.8717937]],
  [[100.5722398,13.8715507],[100.5722529,13.8715439]],
  [[100.5722429,13.8715409],[100.5722498,13.8715537]],
  [[100.5795203,13.8848756],[100.5795334,13.8848688]],
  [[100.5795234,13.8848658],[100.5795303,13.8848786]],
  [[100.5793911,13.8846356],[100.5794042,13.8846288]],
  [[100.5793942,13.8846258],[100.5794011,13.8846386]],
  [[100.5792617,13.8843957],[100.5792748,13.8843889]],
  [[100.5792648,13.8843859],[100.5792717,13.8843987]],
  [[100.5823443,13.890009],[100.5823574,13.8900023]],
  [[100.5823474,13.8899993],[100.5823543,13.8900121]],
  [[100.5822152,13.889769],[100.5822283,13.8897623]],
  [[100.5822183,13.8897592],[100.5822252,13.8897721]],
  [[100.582086,13.889529],[100.5820991,13.8895223]],
  [[100.5820891,13.8895192],[100.582096,13.889532]],
  [[100.5841345,13.8904579],[100.5841382,13.890472]],
  [[100.5841292,13.8904667],[100.5841435,13.8904632]],
  [[100.5838901,13.890613],[100.5838928,13.8906272]],
  [[100.5838842,13.8906214],[100.5838987,13.8906187]],
  [[100.5836173,13.890663],[100.58362,13.8906772]],
  [[100.5836114,13.8906714],[100.5836259,13.8906687]],
  [[100.5833445,13.890713],[100.5833472,13.8907272]],
  [[100.5833385,13.8907214],[100.5833531,13.8907187]],
  [[100.5735368,13.8739395],[100.5735499,13.8739327]],
  [[100.5735399,13.8739297],[100.5735468,13.8739425]],
  [[100.5734076,13.8736995],[100.5734208,13.8736927]],
  [[100.5734108,13.8736897],[100.5734176,13.8737025]],
  [[100.5732785,13.8734595],[100.5732916,13.8734527]],
  [[100.5732816,13.8734497],[100.5732885,13.8734625]],
  [[100.5772292,13.8804262],[100.5772162,13.880433]],
  [[100.5772192,13.8804232],[100.5772262,13.880436]],
  [[100.5769883,13.8802416],[100.5770014,13.8802348]],
  [[100.5769914,13.8802318],[100.5769983,13.8802446]],
  [[100.5768587,13.8800018],[100.5768718,13.879995]],
  [[100.5768618,13.879992],[100.5768687,13.8800048]],
  [[100.5767291,13.879762],[100.5767422,13.8797553]],
  [[100.5767322,13.8797522],[100.5767391,13.879765]],
  [[100.573663,13.8741825],[100.573649,13.8741872]],
  [[100.5736536,13.8741781],[100.5736584,13.8741917]],
  [[100.5737606,13.8741306],[100.5737476,13.8741374]],
  [[100.5737506,13.8741276],[100.5737576,13.8741404]],
  [[100.573728,13.8741476],[100.5737149,13.8741544]],
  [[100.573718,13.8741446],[100.5737249,13.8741574]],
  [[100.573777,13.8741222],[100.5737639,13.8741289]],
  [[100.573767,13.8741192],[100.5737739,13.8741319]],
  [[100.5735323,13.8742504],[100.5735183,13.8742551]],
  [[100.5735229,13.8742459],[100.5735277,13.8742596]],
  [[100.5727384,13.8722134],[100.5727253,13.8722202]],
  [[100.5727283,13.8722104],[100.5727353,13.8722232]],
  [[100.5698703,13.8669363],[100.5698562,13.8669407]],
  [[100.569861,13.8669316],[100.5698655,13.8669454]],
  [[100.571266,13.8694719],[100.5712529,13.8694786]],
  [[100.571256,13.8694689],[100.5712629,13.8694816]],
  [[100.5671273,13.8619163],[100.567114,13.8619228]],
  [[100.5671174,13.8619131],[100.567124,13.861926]],
  [[100.5671437,13.8619086],[100.5671304,13.861915]],
  [[100.5671338,13.8619053],[100.5671403,13.8619183]],
  [[100.5631001,13.8545247],[100.5630868,13.8545311]],
  [[100.5630902,13.8545214],[100.5630967,13.8545344]],
  [[100.5614509,13.8514931],[100.5614376,13.8514995]],
  [[100.561441,13.8514898],[100.5614475,13.8515028]],
  [[100.5615007,13.851469],[100.5614874,13.8514755]],
  [[100.5614908,13.8514658],[100.5614973,13.8514787]],
  [[100.5615671,13.851437],[100.5615538,13.8514434]],
  [[100.5615572,13.8514337],[100.5615637,13.8514467]],
  [[100.5616999,13.8513729],[100.5616866,13.8513793]],
  [[100.5616899,13.8513696],[100.5616965,13.8513826]],
  [[100.5597033,13.8483233],[100.5596905,13.8483304]],
  [[100.5596932,13.8483206],[100.5597006,13.8483332]],
  [[100.5796465,13.8851184],[100.5796325,13.8851231]],
  [[100.5796371,13.8851139],[100.5796419,13.8851276]],
  [[100.5797441,13.8850666],[100.5797311,13.8850733]],
  [[100.5797341,13.8850636],[100.5797411,13.8850763]],
  [[100.5797113,13.8850836],[100.5796982,13.8850904]],
  [[100.5797013,13.8850806],[100.5797082,13.8850934]],
  [[100.5797605,13.8850581],[100.5797474,13.8850649]],
  [[100.5797505,13.8850551],[100.5797574,13.8850679]],
  [[100.5795158,13.8851863],[100.5795018,13.885191]],
  [[100.5795064,13.8851818],[100.5795112,13.8851955]],
  [[100.5825875,13.8901976],[100.5825741,13.8902036]],
  [[100.5825777,13.890194],[100.5825839,13.8902072]],
  [[100.5844772,13.8905166],[100.5844744,13.8905024]],
  [[100.5844685,13.8905109],[100.5844831,13.8905081]],
  [[100.5841957,13.89057],[100.5841929,13.8905558]],
  [[100.584187,13.8905643],[100.5842016,13.8905615]],
  [[100.5839323,13.8906202],[100.5839295,13.890606]],
  [[100.5839236,13.8906145],[100.5839381,13.8906117]],
  [[100.5847446,13.8904691],[100.5847517,13.8904818]],
  [[100.5847417,13.8904789],[100.5847547,13.890472]],
  [[100.5847092,13.8904056],[100.5847163,13.8904183]],
  [[100.5847063,13.8904154],[100.5847193,13.8904085]],
  [[100.5846827,13.890358],[100.5846898,13.8903707]],
  [[100.5846797,13.8903678],[100.5846928,13.8903609]],
  [[100.584823,13.890157],[100.5848201,13.8901428]],
  [[100.5848143,13.8901513],[100.5848288,13.8901484]],
  [[100.5845508,13.8902102],[100.5845479,13.890196]],
  [[100.5845421,13.8902045],[100.5845566,13.8902017]],
  [[100.5842786,13.8902635],[100.5842757,13.8902493]],
  [[100.5842699,13.8902578],[100.5842845,13.8902549]],
  [[100.5852165,13.8903302],[100.5852235,13.890343]],
  [[100.5852135,13.89034],[100.5852265,13.8903332]],
  [[100.5851814,13.8902666],[100.5851884,13.8902793]],
  [[100.5851784,13.8902764],[100.5851914,13.8902695]],
  [[100.5851551,13.8902188],[100.5851621,13.8902315]],
  [[100.5851521,13.8902286],[100.5851651,13.8902217]],
  [[100.5852877,13.8904571],[100.5852925,13.8904708]],
  [[100.5852831,13.8904664],[100.5852971,13.8904616]],
  [[100.5632902,13.8554661],[100.5632847,13.8554526]],
  [[100.5632806,13.855462],[100.5632943,13.8554567]],
  [[100.5633176,13.8555332],[100.5633121,13.8555198]],
  [[100.563308,13.8555292],[100.5633217,13.8555238]],
  [[100.5633382,13.8555836],[100.5633327,13.8555701]],
  [[100.5633286,13.8555796],[100.5633423,13.8555742]],
  [[100.5633519,13.8556172],[100.5633464,13.8556037]],
  [[100.5633423,13.8556131],[100.563356,13.8556078]],
  [[100.5633342,13.8556224],[100.5633287,13.855609]],
  [[100.5633246,13.8556184],[100.5633383,13.855613]],
  [[100.5633165,13.8556276],[100.563311,13.8556142]],
  [[100.5633069,13.8556236],[100.5633206,13.8556182]],
  [[100.5632811,13.8556381],[100.5632756,13.8556246]],
  [[100.5632714,13.8556341],[100.5632852,13.8556287]],
  [[100.5632279,13.8556538],[100.5632224,13.8556403]],
  [[100.5632183,13.8556497],[100.5632321,13.8556444]],
  [[100.5631571,13.8556747],[100.5631516,13.8556613]],
  [[100.5631475,13.8556707],[100.5631612,13.8556653]],
  [[100.5632862,13.8558949],[100.5632773,13.8558833]],
  [[100.5632758,13.8558934],[100.5632877,13.8558848]],
  [[100.5633457,13.855852],[100.5633369,13.8558403]],
  [[100.5633353,13.8558505],[100.5633472,13.8558418]],
  [[100.5633903,13.8558197],[100.5633815,13.8558081]],
  [[100.56338,13.8558182],[100.5633919,13.8558096]],
  [[100.5634201,13.8557982],[100.5634113,13.8557866]],
  [[100.5634097,13.8557967],[100.5634216,13.8557881]],
  [[100.563435,13.8557875],[100.5634261,13.8557759]],
  [[100.5634246,13.855786],[100.5634365,13.8557774]],
  [[100.5634499,13.8557767],[100.563441,13.8557651]],
  [[100.5634395,13.8557753],[100.5634514,13.8557666]],
  [[100.5634692,13.8558076],[100.5634604,13.855796]],
  [[100.5634588,13.8558061],[100.5634707,13.8557974]],
  [[100.5634982,13.8558538],[100.5634894,13.8558422]],
  [[100.5634879,13.8558523],[100.5634998,13.8558437]],
  [[100.5803072,13.8857591],[100.5802943,13.8857663]],
  [[100.5802971,13.8857564],[100.5803044,13.885769]],
  [[100.5803393,13.8857412],[100.5803265,13.8857483]],
  [[100.5803292,13.8857385],[100.5803366,13.885751]],
  [[100.5803875,13.8857143],[100.5803747,13.8857215]],
  [[100.5803774,13.8857116],[100.5803848,13.8857241]],
  [[100.5804518,13.8856784],[100.580439,13.8856856]],
  [[100.5804417,13.8856757],[100.5804491,13.8856883]],
  [[100.5801018,13.8858737],[100.5801146,13.8858665]],
  [[100.5801045,13.8858638],[100.5801119,13.8858764]],
  [[100.5800696,13.8858916],[100.5800825,13.8858844]],
  [[100.5800724,13.8858817],[100.5800797,13.8858943]],
  [[100.5800214,13.8859185],[100.5800343,13.8859113]],
  [[100.5800242,13.8859086],[100.5800315,13.8859212]],
  [[100.5799572,13.8859544],[100.57997,13.8859472]],
  [[100.5799599,13.8859445],[100.5799673,13.885957]],
  [[100.5603894,13.8493586],[100.5603965,13.8493714]],
  [[100.5603864,13.8493685],[100.5603995,13.8493616]],
  [[100.5601938,13.8494611],[100.5602007,13.8494739]],
  [[100.5602038,13.8494641],[100.5601907,13.8494709]],
  [[100.5676316,13.862598],[100.5676184,13.8626044]],
  [[100.5676217,13.8625947],[100.5676283,13.8626077]],
  [[100.5676647,13.8625818],[100.5676515,13.8625882]],
  [[100.5676548,13.8625785],[100.5676614,13.8625915]],
  [[100.5677143,13.8625574],[100.5677011,13.8625639]],
  [[100.5677044,13.8625542],[100.567711,13.8625672]],
  [[100.5677805,13.862525],[100.5677672,13.8625315]],
  [[100.5677705,13.8625218],[100.5677772,13.8625347]],
  [[100.5674202,13.8627016],[100.5674334,13.8626951]],
  [[100.5674235,13.8626918],[100.5674301,13.8627048]],
  [[100.5673871,13.8627178],[100.5674004,13.8627113]],
  [[100.5673904,13.862708],[100.5673971,13.862721]],
  [[100.5673375,13.8627421],[100.5673507,13.8627356]],
  [[100.5673408,13.8627324],[100.5673474,13.8627453]],
  [[100.5672713,13.8627745],[100.5672846,13.862768]],
  [[100.5672746,13.8627648],[100.5672813,13.8627777]],
  [[100.5703416,13.8675657],[100.5703285,13.8675725]],
  [[100.5703316,13.8675627],[100.5703386,13.8675755]],
  [[100.5703742,13.8675486],[100.5703611,13.8675554]],
  [[100.5703642,13.8675456],[100.5703712,13.8675584]],
  [[100.5704231,13.8675229],[100.5704101,13.8675298]],
  [[100.5704131,13.86752],[100.5704201,13.8675327]],
  [[100.5704883,13.8674887],[100.5704753,13.8674956]],
  [[100.5704783,13.8674858],[100.5704853,13.8674985]],
  [[100.5701332,13.8676749],[100.5701462,13.8676681]],
  [[100.5701362,13.8676651],[100.5701432,13.8676779]],
  [[100.5701006,13.867692],[100.5701136,13.8676852]],
  [[100.5701036,13.8676822],[100.5701106,13.867695]],
  [[100.5700517,13.8677177],[100.5700647,13.8677108]],
  [[100.5700547,13.8677079],[100.5700617,13.8677206]],
  [[100.5699864,13.8677519],[100.5699995,13.867745]],
  [[100.5699895,13.8677421],[100.5699965,13.8677548]],
  [[100.5731935,13.8728951],[100.5731801,13.8729013]],
  [[100.5731837,13.8728917],[100.57319,13.8729048]],
  [[100.573227,13.8728797],[100.5732136,13.8728859]],
  [[100.5732171,13.8728763],[100.5732234,13.8728893]],
  [[100.5732772,13.8728566],[100.5732638,13.8728627]],
  [[100.5732673,13.8728531],[100.5732737,13.8728662]],
  [[100.5733441,13.8728257],[100.5733307,13.8728319]],
  [[100.5733343,13.8728223],[100.5733406,13.8728354]],
  [[100.5729796,13.8729937],[100.572993,13.8729876]],
  [[100.5729831,13.8729841],[100.5729894,13.8729972]],
  [[100.5729461,13.8730092],[100.5729595,13.873003]],
  [[100.5729497,13.8729995],[100.572956,13.8730126]],
  [[100.5728959,13.8730323],[100.5729093,13.8730261]],
  [[100.5728995,13.8730227],[100.5729058,13.8730358]],
  [[100.572829,13.8730632],[100.5728424,13.873057]],
  [[100.5728325,13.8730535],[100.5728388,13.8730666]],
  [[100.5763528,13.8785972],[100.5763398,13.8786041]],
  [[100.5763428,13.8785943],[100.5763498,13.878607]],
  [[100.5763854,13.8785801],[100.5763723,13.8785869]],
  [[100.5763753,13.8785771],[100.5763824,13.8785899]],
  [[100.5764342,13.8785543],[100.5764212,13.8785612]],
  [[100.5764242,13.8785514],[100.5764312,13.8785641]],
  [[100.5764994,13.87852],[100.5764863,13.8785269]],
  [[100.5764894,13.8785171],[100.5764964,13.8785298]],
  [[100.5761446,13.8787069],[100.5761576,13.8787]],
  [[100.5761476,13.8786971],[100.5761546,13.8787098]],
  [[100.576112,13.878724],[100.576125,13.8787172]],
  [[100.576115,13.8787142],[100.576122,13.878727]],
  [[100.5760631,13.8787498],[100.5760762,13.8787429]],
  [[100.5760661,13.87874],[100.5760732,13.8787527]],
  [[100.575998,13.8787841],[100.576011,13.8787772]],
  [[100.576001,13.8787743],[100.576008,13.878787]],
  [[100.5859351,13.8900103],[100.5859381,13.8900245]],
  [[100.5859293,13.8900188],[100.5859439,13.890016]],
  [[100.5859278,13.8899749],[100.5859308,13.8899891]],
  [[100.585922,13.8899834],[100.5859366,13.8899805]],
  [[100.5859169,13.8899217],[100.5859198,13.8899359]],
  [[100.5859111,13.8899302],[100.5859256,13.8899274]],
  [[100.5859023,13.8898508],[100.5859052,13.889865]],
  [[100.5858965,13.8898593],[100.585911,13.8898565]],
  [[100.5860318,13.890227],[100.5860288,13.8902129]],
  [[100.586023,13.8902214],[100.5860376,13.8902185]],
  [[100.5860391,13.8902625],[100.5860361,13.8902483]],
  [[100.5860303,13.8902568],[100.5860449,13.890254]],
  [[100.58605,13.8903157],[100.5860471,13.8903015]],
  [[100.5860413,13.89031],[100.5860558,13.8903071]],
  [[100.5860646,13.8903865],[100.5860617,13.8903723]],
  [[100.5860559,13.8903809],[100.5860704,13.890378]],
  [[100.591473,13.8887403],[100.591478,13.888754]],
  [[100.5914686,13.8887496],[100.5914825,13.8887447]],
  [[100.5914606,13.8887063],[100.5914656,13.8887199]],
  [[100.5914561,13.8887155],[100.5914701,13.8887107]],
  [[100.5914419,13.8886552],[100.5914469,13.8886689]],
  [[100.5914375,13.8886645],[100.5914514,13.8886596]],
  [[100.591417,13.8885871],[100.591422,13.8886008]],
  [[100.5914126,13.8885964],[100.5914265,13.8885915]],
  [[100.5916006,13.8889412],[100.5915956,13.8889276]],
  [[100.5915911,13.8889369],[100.5916051,13.888932]],
  [[100.591613,13.8889753],[100.591608,13.8889617]],
  [[100.5916035,13.8889709],[100.5916175,13.888966]],
  [[100.5916317,13.8890264],[100.5916267,13.8890127]],
  [[100.5916222,13.889022],[100.5916362,13.8890171]],
  [[100.5916566,13.8890945],[100.5916516,13.8890808]],
  [[100.5916471,13.8890901],[100.5916611,13.8890852]],
  [[100.5535972,13.8369603],[100.5536043,13.836973]],
  [[100.5535942,13.8369701],[100.5536072,13.8369632]],
  [[100.5535796,13.8369285],[100.5535867,13.8369412]],
  [[100.5535766,13.8369383],[100.5535896,13.8369314]],
  [[100.5535532,13.8368808],[100.5535603,13.8368935]],
  [[100.5535502,13.8368906],[100.5535632,13.8368837]],
  [[100.553518,13.8368172],[100.553525,13.8368299]],
  [[100.553515,13.836827],[100.553528,13.8368201]],
  [[100.5549169,13.8390625],[100.5549021,13.8390626]],
  [[100.5549095,13.8390553],[100.5549096,13.8390698]],
  [[100.5545208,13.839125],[100.5545062,13.8391273]],
  [[100.5545123,13.839119],[100.5545147,13.8391333]],
  [[100.5545945,13.8391131],[100.5545799,13.8391155]],
  [[100.554586,13.8391072],[100.5545884,13.8391214]],
  [[100.5546314,13.8391072],[100.5546168,13.8391096]],
  [[100.5546229,13.8391012],[100.5546253,13.8391155]],
  [[100.5546519,13.8391039],[100.5546372,13.8391063]],
  [[100.5546433,13.839098],[100.5546457,13.8391122]],
  [[100.5546705,13.8391009],[100.5546558,13.8391033]],
  [[100.5546619,13.839095],[100.5546643,13.8391093]],
  [[100.5543739,13.8391523],[100.5543591,13.8391524]],
  [[100.5543664,13.8391451],[100.5543665,13.8391596]],
  [[100.5547043,13.8390955],[100.5546897,13.8390979]],
  [[100.5546958,13.8390895],[100.5546982,13.8391038]],
  [[100.5547728,13.8390845],[100.5547582,13.8390869]],
  [[100.5547643,13.8390785],[100.5547667,13.8390928]],
  [[100.5600597,13.8492317],[100.5600727,13.8492249]],
  [[100.5600627,13.8492219],[100.5600697,13.8492347]],
  [[100.5599282,13.8489929],[100.5599412,13.8489861]],
  [[100.5599312,13.8489831],[100.5599382,13.8489959]],
  [[100.5597967,13.8487542],[100.5598097,13.8487473]],
  [[100.5597997,13.8487444],[100.5598067,13.8487571]],
  [[100.5564523,13.8426577],[100.5564592,13.8426705]],
  [[100.5564623,13.8426607],[100.5564492,13.8426674]],
  [[100.5563182,13.8424283],[100.5563312,13.8424214]],
  [[100.5563212,13.8424185],[100.5563282,13.8424312]],
  [[100.5561867,13.8421895],[100.5561997,13.8421827]],
  [[100.5561897,13.8421797],[100.5561967,13.8421925]],
  [[100.5560552,13.8419507],[100.5560682,13.8419439]],
  [[100.5560582,13.8419409],[100.5560652,13.8419537]],
  [[100.5566962,13.8425282],[100.556703,13.8425411]],
  [[100.5567062,13.8425313],[100.556693,13.842538]],
  [[100.5565607,13.8422996],[100.5565737,13.8422927]],
  [[100.5565637,13.8422898],[100.5565707,13.8423025]],
  [[100.5564292,13.8420608],[100.5564422,13.8420539]],
  [[100.5564322,13.842051],[100.5564392,13.8420637]],
  [[100.5562977,13.841822],[100.5563107,13.8418151]],
  [[100.5563007,13.8418122],[100.5563077,13.8418249]],
  [[100.5602584,13.8491196],[100.5602653,13.8491324]],
  [[100.5602684,13.8491227],[100.5602553,13.8491294]],
  [[100.5601242,13.8488902],[100.5601373,13.8488834]],
  [[100.5601273,13.8488804],[100.5601343,13.8488932]],
  [[100.5599903,13.848655],[100.5600034,13.8486481]],
  [[100.5599933,13.8486452],[100.5600004,13.8486579]],
  [[100.5568286,13.8427665],[100.5568355,13.8427793]],
  [[100.5568386,13.8427696],[100.5568255,13.8427763]],
  [[100.5565848,13.842896],[100.5565916,13.8429088]],
  [[100.5565948,13.842899],[100.5565816,13.8429057]],
  [[100.5565185,13.8427768],[100.5565254,13.8427896]],
  [[100.5565285,13.8427799],[100.5565154,13.8427866]],
  [[100.5563861,13.8425385],[100.556393,13.8425513]],
  [[100.5563961,13.8425416],[100.556383,13.8425483]],
  [[100.5566299,13.8424091],[100.5566368,13.8424219]],
  [[100.5566399,13.8424121],[100.5566268,13.8424189]],
  [[100.5567624,13.8426474],[100.5567693,13.8426602]],
  [[100.5567724,13.8426504],[100.5567593,13.8426572]],
  [[100.5562525,13.8423088],[100.5562656,13.8423019]],
  [[100.5562555,13.842299],[100.5562625,13.8423117]],
  [[100.5564952,13.8421806],[100.5565082,13.8421738]],
  [[100.5564982,13.8421708],[100.5565052,13.8421836]],
  [[100.5563631,13.8419408],[100.5563762,13.841934]],
  [[100.5563661,13.841931],[100.5563732,13.8419438]],
  [[100.5561209,13.8420702],[100.556134,13.8420633]],
  [[100.556124,13.8420604],[100.556131,13.8420731]],
  [[100.5602427,13.8494355],[100.5602496,13.8494483]],
  [[100.5602527,13.8494385],[100.5602396,13.8494452]],
  [[100.5602917,13.8494099],[100.5602985,13.8494227]],
  [[100.5603017,13.8494129],[100.5602885,13.8494196]],
  [[100.5603406,13.8493842],[100.5603475,13.849397]],
  [[100.5603506,13.8493873],[100.5603375,13.849394]],
  [[100.5604384,13.849333],[100.5604453,13.8493458]],
  [[100.5604484,13.849336],[100.5604353,13.8493428]],
  [[100.5604873,13.8493074],[100.5604942,13.8493202]],
  [[100.5604973,13.8493104],[100.5604842,13.8493171]],
  [[100.5601449,13.8494867],[100.5601518,13.8494995]],
  [[100.5601549,13.8494898],[100.5601418,13.8494965]],
  [[100.560096,13.8495123],[100.5601029,13.8495252]],
  [[100.560106,13.8495154],[100.5600929,13.8495221]],
  [[100.5630835,13.8545327],[100.5630702,13.8545391]],
  [[100.5630736,13.8545294],[100.5630802,13.8545424]],
  [[100.5630503,13.8545487],[100.5630371,13.8545551]],
  [[100.5630404,13.8545454],[100.563047,13.8545584]],
  [[100.562984,13.8545807],[100.5629707,13.8545871]],
  [[100.5629741,13.8545774],[100.5629806,13.8545904]],
  [[100.5628513,13.8546448],[100.562838,13.8546512]],
  [[100.5628414,13.8546415],[100.5628479,13.8546545]],
  [[100.5631037,13.8545229],[100.563117,13.8545165]],
  [[100.5631071,13.8545132],[100.5631136,13.8545262]],
  [[100.5631369,13.8545069],[100.5631502,13.8545005]],
  [[100.5631402,13.8544972],[100.5631468,13.8545102]],
  [[100.5632032,13.8544749],[100.5632165,13.8544685]],
  [[100.5632066,13.8544652],[100.5632132,13.8544782]],
  [[100.5633359,13.8544108],[100.5633492,13.8544044]],
  [[100.5633393,13.8544011],[100.5633459,13.8544141]],
  [[100.5596872,13.8483322],[100.5596744,13.8483394]],
  [[100.5596771,13.8483295],[100.5596845,13.8483421]],
  [[100.5596551,13.8483501],[100.5596422,13.8483573]],
  [[100.559645,13.8483474],[100.5596523,13.84836]],
  [[100.5595907,13.8483859],[100.5595779,13.848393]],
  [[100.5595807,13.8483831],[100.559588,13.8483957]],
  [[100.5594621,13.8484574],[100.5594492,13.8484645]],
  [[100.559452,13.8484547],[100.5594593,13.8484673]],
  [[100.5597065,13.8483215],[100.5597194,13.8483143]],
  [[100.5597093,13.8483116],[100.5597166,13.8483242]],
  [[100.5597387,13.8483036],[100.5597516,13.8482964]],
  [[100.5597415,13.8482937],[100.5597488,13.8483063]],
  [[100.559803,13.8482678],[100.5598159,13.8482607]],
  [[100.5598058,13.848258],[100.5598131,13.8482706]],
  [[100.5599317,13.8481963],[100.5599446,13.8481892]],
  [[100.5599345,13.8481864],[100.5599418,13.848199]],
  [[100.5614675,13.8514851],[100.5614542,13.8514915]],
  [[100.5614576,13.8514818],[100.5614641,13.8514948]],
  [[100.5613879,13.8515235],[100.5614012,13.8515171]],
  [[100.5613912,13.8515138],[100.5613978,13.8515268]],
  [[100.5613215,13.8515556],[100.5613348,13.8515491]],
  [[100.5613249,13.8515459],[100.5613315,13.8515588]],
  [[100.5611887,13.8516197],[100.5612019,13.8516133]],
  [[100.561192,13.85161],[100.5611986,13.851623]],
  [[100.5614211,13.8515075],[100.5614344,13.8515011]],
  [[100.5614245,13.8514978],[100.5614311,13.8515108]],
  [[100.5670941,13.8619325],[100.5670808,13.8619389]],
  [[100.5670842,13.8619293],[100.5670907,13.8619422]],
  [[100.5670277,13.8619646],[100.5670145,13.861971]],
  [[100.5670178,13.8619613],[100.5670244,13.8619743]],
  [[100.5668971,13.8620327],[100.5668838,13.8620391]],
  [[100.5668872,13.8620294],[100.5668937,13.8620424]],
  [[100.5671464,13.8619064],[100.5671592,13.8618992]],
  [[100.5671491,13.8618965],[100.5671565,13.8619091]],
  [[100.5671306,13.8619154],[100.5671435,13.8619082]],
  [[100.5671334,13.8619055],[100.5671408,13.8619181]],
  [[100.5671787,13.8618885],[100.5671915,13.8618813]],
  [[100.5671814,13.8618786],[100.5671888,13.8618912]],
  [[100.5672429,13.8618525],[100.5672557,13.8618453]],
  [[100.5672456,13.8618426],[100.567253,13.8618552]],
  [[100.5673736,13.8617845],[100.5673864,13.8617773]],
  [[100.5673763,13.8617747],[100.5673837,13.8617872]],
  [[100.5698527,13.8669418],[100.5698386,13.8669462]],
  [[100.5698434,13.8669371],[100.5698479,13.8669509]],
  [[100.5698176,13.8669527],[100.5698035,13.8669571]],
  [[100.5698083,13.866948],[100.5698128,13.8669618]],
  [[100.5697471,13.8669747],[100.569733,13.8669791]],
  [[100.5697378,13.86697],[100.5697423,13.8669838]],
  [[100.569606,13.8670187],[100.5695919,13.8670231]],
  [[100.5695967,13.867014],[100.5696012,13.8670278]],
  [[100.5698562,13.8669407],[100.5698703,13.8669363]],
  [[100.569861,13.8669316],[100.5698655,13.8669454]],
  [[100.5698739,13.8669352],[100.569888,13.8669308]],
  [[100.5698787,13.8669261],[100.5698832,13.8669399]],
  [[100.569909,13.8669243],[100.5699231,13.8669199]],
  [[100.5699138,13.8669152],[100.5699183,13.866929]],
  [[100.5699795,13.8669023],[100.5699936,13.8668979]],
  [[100.5699843,13.8668932],[100.5699888,13.866907]],
  [[100.5701206,13.8668584],[100.5701347,13.866854]],
  [[100.5701254,13.8668493],[100.5701299,13.8668631]],
  [[100.5712496,13.8694803],[100.5712365,13.8694871]],
  [[100.5712396,13.8694773],[100.5712466,13.8694901]],
  [[100.5712171,13.8694972],[100.571204,13.869504]],
  [[100.5712071,13.8694942],[100.571214,13.869507]],
  [[100.5711516,13.8695312],[100.5711385,13.869538]],
  [[100.5711416,13.8695282],[100.5711485,13.869541]],
  [[100.5710209,13.869599],[100.5710078,13.8696058]],
  [[100.5710108,13.869596],[100.5710178,13.8696088]],
  [[100.5712693,13.8694703],[100.5712825,13.8694638]],
  [[100.5712726,13.8694606],[100.5712793,13.8694735]],
  [[100.5713022,13.8694541],[100.5713155,13.8694476]],
  [[100.5713055,13.8694444],[100.5713122,13.8694573]],
  [[100.5713684,13.8694214],[100.5713816,13.8694149]],
  [[100.5713717,13.8694117],[100.5713784,13.8694246]],
  [[100.5715005,13.8693561],[100.5715137,13.8693496]],
  [[100.5715038,13.8693464],[100.5715105,13.8693593]],
  [[100.572722,13.8722217],[100.5727089,13.8722285]],
  [[100.5727119,13.8722187],[100.5727189,13.8722315]],
  [[100.5726895,13.8722387],[100.5726764,13.8722455]],
  [[100.5726795,13.8722357],[100.5726864,13.8722485]],
  [[100.5726238,13.8722725],[100.5726108,13.8722792]],
  [[100.5726138,13.8722695],[100.5726208,13.8722822]],
  [[100.5724928,13.8723395],[100.5724798,13.8723463]],
  [[100.5724828,13.8723365],[100.5724898,13.8723493]],
  [[100.5727416,13.8722116],[100.5727546,13.8722048]],
  [[100.5727446,13.8722018],[100.5727516,13.8722146]],
  [[100.5727742,13.8721948],[100.5727872,13.872188]],
  [[100.5727772,13.872185],[100.5727842,13.8721978]],
  [[100.5728395,13.8721606],[100.5728526,13.8721538]],
  [[100.5728426,13.8721508],[100.5728495,13.8721636]],
  [[100.5729698,13.8720921],[100.5729828,13.8720853]],
  [[100.5729728,13.8720823],[100.5729798,13.8720951]],
  [[100.5738799,13.8740723],[100.5738918,13.8740638]],
  [[100.5738815,13.8740622],[100.5738902,13.8740739]],
  [[100.5737803,13.8741206],[100.5737935,13.8741141]],
  [[100.5737836,13.8741109],[100.5737903,13.8741238]],
  [[100.5738133,13.8741042],[100.5738265,13.8740976]],
  [[100.5738165,13.8740945],[100.5738233,13.8741074]],
  [[100.5740118,13.8740067],[100.5740237,13.8739981]],
  [[100.5740134,13.8739965],[100.5740221,13.8740083]],
  [[100.579863,13.8850082],[100.5798749,13.8849997]],
  [[100.5798646,13.8849981],[100.5798733,13.8850098]],
  [[100.5797635,13.8850567],[100.5797767,13.8850501]],
  [[100.5797668,13.8850469],[100.5797735,13.8850598]],
  [[100.5797966,13.8850401],[100.5798098,13.8850336]],
  [[100.5797999,13.8850304],[100.5798066,13.8850433]],
  [[100.5799948,13.8849424],[100.5800067,13.8849338]],
  [[100.5799964,13.8849323],[100.5800051,13.884944]],
  [[100.5772129,13.8804347],[100.5771998,13.8804415]],
  [[100.5772029,13.8804317],[100.5772098,13.8804445]],
  [[100.5771802,13.8804516],[100.5771671,13.8804584]],
  [[100.5771702,13.8804486],[100.5771771,13.8804614]],
  [[100.5771148,13.8804855],[100.5771018,13.8804923]],
  [[100.5771048,13.8804825],[100.5771118,13.8804953]],
  [[100.5769841,13.8805533],[100.576971,13.8805601]],
  [[100.5769741,13.8805504],[100.576981,13.8805631]],
  [[100.5772325,13.8804245],[100.5772456,13.8804177]],
  [[100.5772356,13.8804147],[100.5772425,13.8804275]],
  [[100.5772652,13.8804075],[100.5772782,13.8804007]],
  [[100.5772682,13.8803977],[100.5772752,13.8804105]],
  [[100.5773305,13.8803735],[100.5773436,13.8803667]],
  [[100.5773336,13.8803637],[100.5773405,13.8803765]],
  [[100.5774612,13.8803055],[100.5774742,13.8802987]],
  [[100.5774642,13.8802958],[100.5774712,13.8803085]],
  [[100.5825707,13.8902051],[100.5825572,13.8902112]],
  [[100.5825609,13.8902016],[100.5825671,13.8902147]],
  [[100.5825371,13.8902202],[100.5825236,13.8902262]],
  [[100.5825272,13.8902166],[100.5825334,13.8902298]],
  [[100.5824697,13.8902503],[100.5824563,13.8902563]],
  [[100.5824599,13.8902467],[100.5824661,13.8902599]],
  [[100.5823351,13.8903105],[100.5823216,13.8903165]],
  [[100.5823253,13.8903069],[100.5823315,13.8903201]],
  [[100.5825907,13.8901957],[100.5826039,13.8901892]],
  [[100.582594,13.890186],[100.5826007,13.890199]],
  [[100.5826238,13.8901795],[100.582637,13.890173]],
  [[100.582627,13.8901698],[100.5826337,13.8901827]],
  [[100.5826899,13.8901469],[100.5827031,13.8901404]],
  [[100.5826932,13.8901372],[100.5826998,13.8901501]],
  [[100.5828221,13.8900818],[100.5828353,13.8900753]],
  [[100.5828254,13.8900721],[100.582832,13.890085]],
  [[100.5841391,13.8904755],[100.5841427,13.8904895]],
  [[100.5841337,13.8904843],[100.5841481,13.8904807]],
  [[100.5841482,13.8905105],[100.5841518,13.8905245]],
  [[100.5841428,13.8905193],[100.5841572,13.8905157]],
  [[100.5841664,13.8905806],[100.58417,13.8905946]],
  [[100.584161,13.8905894],[100.5841754,13.8905858]],
  [[100.5842028,13.8907208],[100.5842065,13.8907348]],
  [[100.5841975,13.8907296],[100.5842118,13.890726]],
  [[100.5841336,13.8904544],[100.58413,13.8904404]],
  [[100.5841246,13.8904492],[100.584139,13.8904457]],
  [[100.5841245,13.8904194],[100.5841208,13.8904054]],
  [[100.5841155,13.8904142],[100.5841298,13.8904106]],
  [[100.5841063,13.8903493],[100.5841026,13.8903353]],
  [[100.5840973,13.8903441],[100.5841116,13.8903405]],
  [[100.5840698,13.8902091],[100.5840662,13.8901951]],
  [[100.5840608,13.8902039],[100.5840752,13.8902004]],
  [[100.5848154,13.8905961],[100.5848225,13.8906088]],
  [[100.5848124,13.8906059],[100.5848255,13.890599]],
  [[100.5846915,13.8903738],[100.5846986,13.8903865]],
  [[100.5846886,13.8903836],[100.5847016,13.8903767]],
  [[100.5846739,13.8903421],[100.584681,13.8903548]],
  [[100.5846709,13.8903519],[100.5846839,13.890345]],
  [[100.5846562,13.8903103],[100.5846633,13.890323]],
  [[100.5846533,13.8903201],[100.5846663,13.8903132]],
  [[100.584621,13.8902467],[100.5846281,13.8902594]],
  [[100.584618,13.8902565],[100.584631,13.8902496]],
  [[100.5845505,13.8901196],[100.5845575,13.8901323]],
  [[100.5845475,13.8901294],[100.5845605,13.8901225]],
  [[100.5851638,13.8902347],[100.5851709,13.8902475]],
  [[100.5851608,13.8902445],[100.5851739,13.8902377]],
  [[100.5851007,13.8901201],[100.5850937,13.8901074]],
  [[100.5850907,13.8901172],[100.5851037,13.8901103]],
  [[100.5851358,13.8901838],[100.5851288,13.890171]],
  [[100.5851258,13.8901808],[100.5851388,13.890174]],
  [[100.5850315,13.8899922],[100.5850226,13.8899806]],
  [[100.5850211,13.8899908],[100.5850329,13.889982]],
  [[100.5851533,13.8902156],[100.5851463,13.8902029]],
  [[100.5851433,13.8902127],[100.5851563,13.8902058]],
  [[100.5504571,13.8321395],[100.5504653,13.8321515]],
  [[100.5504674,13.8321415],[100.550455,13.8321495]],
  [[100.5504171,13.8320797],[100.5504253,13.8320918]],
  [[100.5504274,13.8320817],[100.5504151,13.8320898]],
  [[100.5504633,13.8320496],[100.5504715,13.8320616]],
  [[100.5504735,13.8320516],[100.5504612,13.8320596]],
  [[100.550494,13.8320295],[100.5505022,13.8320415]],
  [[100.5505043,13.8320315],[100.550492,13.8320396]],
  [[100.5505094,13.8320195],[100.5505176,13.8320315]],
  [[100.5505197,13.8320215],[100.5505074,13.8320295]],
  [[100.5505248,13.8320094],[100.550533,13.8320215]],
  [[100.5505351,13.8320114],[100.5505227,13.8320195]],
  [[100.5505555,13.8319893],[100.5505638,13.8320014]],
  [[100.5505658,13.8319913],[100.5505535,13.8319994]],
  [[100.5505527,13.8319352],[100.5505609,13.8319472]],
  [[100.550563,13.8319372],[100.5505507,13.8319452]],
  [[100.5505906,13.8319973],[100.5505988,13.8320093]],
  [[100.5506009,13.8319993],[100.5505886,13.8320073]],
  [[100.5814573,13.8884511],[100.5814509,13.8884381]],
  [[100.5814608,13.8884415],[100.5814474,13.8884477]],
  [[100.5635369,13.8559155],[100.563528,13.8559039]],
  [[100.5635265,13.8559141],[100.5635384,13.8559054]],
];

// MapLibre GeoJSON source: one MultiLineString feature holding all strokes
export function settlementGeoJSON() {
  return {
    type: "FeatureCollection",
    features: [{ type: "Feature", properties: {}, geometry: { type: "MultiLineString", coordinates: SETTLEMENT_CROSSES } }],
  };
}
